import type { FloatingIconConfig } from "./hooks/useFloatingIcons.types";
import { ActivityType } from "../../modules/homeDisplay/types/homeDisplay.types";

/** 与 `Event` 组件内 `iconsToRender` 的显隐规则一致 */
export interface CornerFloatingIconsVisibility {
  firstRechargeVisible?: boolean;
  cashbackVisible?: boolean;
  redPacketVisible?: boolean;
  rescueFundVisible?: boolean;
}

/**
 * 右下角浮标与首页 Benefit 活动行共用：与 {@link Event} 中 `iconsToRender` 逻辑保持同一实现，
 * 避免 Benefit 区用后台全量配置多出展示。
 */
export function filterFloatingIconsForCornerDisplay(
  icons: FloatingIconConfig[],
  visibility: CornerFloatingIconsVisibility
): FloatingIconConfig[] {
  const {
    firstRechargeVisible = true,
    cashbackVisible,
    redPacketVisible = true,
    rescueFundVisible = true,
  } = visibility;

  return icons.filter(icon => {
    let shouldRender = icon.shouldShow;
    if (
      (icon.activityType === ActivityType.FIRST_DEPOSIT ||
        icon.activityType === ActivityType.FIRST_RECHARGE_STAGED) &&
      !firstRechargeVisible
    )
      shouldRender = false;
    if (
      icon.activityType === ActivityType.RED_PACKET_RAIN &&
      !redPacketVisible
    )
      shouldRender = false;
    if (
      icon.activityType === ActivityType.FIVE_DAILY_RECHARGE &&
      cashbackVisible !== undefined &&
      !cashbackVisible
    )
      shouldRender = false;
    if (
      icon.activityType === ActivityType.RESCUE_FUND &&
      !rescueFundVisible
    )
      shouldRender = false;
    return shouldRender;
  });
}

/**
 * 须与 `App.tsx` 里 `<GlobalEvent />` 传入的浮标开关保持一致（Benefit 区活动行同步过滤）。
 */
export const APP_GLOBAL_EVENT_FLOATING_VISIBILITY: CornerFloatingIconsVisibility =
  {
    firstRechargeVisible: false,
    cashbackVisible: false,
    redPacketVisible: false,
    rescueFundVisible: false,
  };
